import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAllVehicle,
} from "../../../../features/admin/master/vehicle/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";

import { getAllVehicleCatWithoutType } from "../../../../features/admin/common/Slice";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";
const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const vehicleList = useSelector(
    (state) => state.common.all_vehicle_category_without_type,
  );
  const vehicleType = [
    { value: "cab", label: "Cab" },
    { value: "transport", label: "Transport" },
  ];
  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    setError,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        const responseData = res?.payload?.data?.data;
        reset(responseData);

        // Match the type string to the select option object
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const selectedType = watch("type");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("fare", data?.fare);

      sendData.append("type", data?.type);
      if (data?.type === "Cab") {
        sendData.append("seats", data?.seats || "");
        sendData.append("capacity", "");
      } else if (data?.type === "Transport") {
        sendData.append("capacity", data?.capacity || "");
        sendData.append("seats", "");
      } else if (data?.type === "Share") {
        sendData.append("capacity", "");
        sendData.append("seats", data?.seats || "");
      }

      sendData.append("vehicle_category_id", data?.vehicle_category_id?.value);
      sendData.append("image", data?.image[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAllVehicle());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({
          name: "",
          vehicle_category_id: "",
          type: "",
          seats: "",
          capacity: "",
        });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload == 406) {
        await setError("name", {
          type: "manual",
          message: "Vehicle Already Exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };

  useEffect(() => {
    dispatch(getAllVehicleCatWithoutType());
  }, [dispatch]);

  return (
    <>
      <Add_section_title
        title={id ? "Edit Vehicle" : "Add Vehicle "}
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Vehicle Category</Form.Label>
                <Controller
                  name="vehicle_category_id" // name of the field
                  {...register("vehicle_category_id", {
                    required: "Select Vehicle Category",
                  })}
                  control={control}
                  render={({ field }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors.vehicle_category_id
                            ? "red"
                            : baseStyles,
                        }),
                      }}
                      {...field}
                      options={vehicleList}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);

                        // Extract text inside brackets
                        const match = selectedOption?.label.match(/\((.*?)\)/);

                        if (match && match[1]) {
                          setValue("type", match[1]);
                        }
                      }}
                    />
                  )}
                />
                {errors.vehicle_category_id && (
                  <span className="text-danger">
                    {errors.vehicle_category_id.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Type</Form.Label>
                <Form.Select
                  style={{
                    pointerEvents: "none",
                    backgroundColor: "#e9ecef",
                  }}
                  {...register("type", {
                    required: "Type is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.type,
                  })}
                >
                  <option value="">Select Type</option>
                  <option value="Transport">Transport</option>
                  <option value="Cab">Cab</option>
                  <option value="Share">Share</option>
                </Form.Select>
                {errors.type && (
                  <span className="text-danger">{errors.type?.message}</span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              {(selectedType === "Cab" || selectedType === "Share") && (
                <div className="form-group">
                  <Form.Label>Seats</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Number of Seats"
                    {...register("seats", {
                      required: "Seats are Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.seats,
                    })}
                  />
                  {errors.seats && (
                    <span className="text-danger">{errors.seats.message}</span>
                  )}
                </div>
              )}
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              {selectedType === "Transport" && (
                <div className="form-group">
                  <Form.Label>Capacity</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Transport Capacity"
                    {...register("capacity", {
                      required: "Capacity is required for Transport",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.capacity,
                    })}
                  />
                  {errors.capacity && (
                    <span className="text-danger">
                      {errors.capacity.message}
                    </span>
                  )}
                </div>
              )}
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Name"
                  {...register("name", {
                    required: "Name is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.name && (
                  <span className="text-danger">{errors.name?.message}</span>
                )}
              </div>{" "}
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Fare (per Km)</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Fare"
                  min="0"
                  // onInput={(e) => {
                  //   e.target.value = Math.max(
                  //     0,
                  //     e.target.value || 0
                  //   );
                  // }}
                  {...register("fare", {
                    required: "Fare is Required",
                    min: {
                      value: 0,
                      message: "Fare cannot be negative",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.fare,
                  })}
                />

                {errors.fare && (
                  <span className="text-danger">{errors.fare?.message}</span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group
                className="form-field mb-3"
                controlId="formBasicEmail"
              >
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    // required: image_required
                    //   ? "Image is required"
                    //   : image_required,
                    required:
                      typeof getValues("image") == "string"
                        ? false
                        : " Image is required",
                    validate: async (value) => {
                      // if (typeof value !== "string") {
                      //   const fileTypes = ["jpg", "png", "jpeg"];
                      //   const fileType = value[0].name?.split(".")[1];
                      //   if (!fileTypes.includes(fileType)) {
                      //     return `please upload a valid file format. (${fileTypes})`;
                      //   }
                      // }
                    },
                  })}
                  //   {...register("image", {
                  //     validate: (value) => {
                  //       const currentImage = getValues("image");

                  //       if (
                  //         image_required &&
                  //         typeof currentImage !== "string" &&
                  //         (!value || value.length === 0)
                  //       ) {
                  //         return "Image is required";
                  //       }

                  //       return true;
                  //     },
                  //   })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </Form.Group>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3">
                <Form.Label className="text-center">Image Preview</Form.Label>
                {typeof getValues("image") == "string" ? (
                  <div className="image-preview-container">
                    <img
                      src={IDS.IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ width: "150px", height: "130px" }}
                    />
                  </div>
                ) : (
                  imageFile &&
                  imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        // src={URL.createObjectURL(getValues("image")[0])}
                        src={URL?.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                    </div>
                  )
                )}
              </Form.Group>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        reset({ name: "" });
                        setId("");
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
